import { render, staticRenderFns } from "./BookResultRow.vue?vue&type=template&id=5d4cd3ea&scoped=true"
import script from "./BookResultRow.vue?vue&type=script&lang=js"
export * from "./BookResultRow.vue?vue&type=script&lang=js"
import style0 from "./BookResultRow.vue?vue&type=style&index=0&id=5d4cd3ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4cd3ea",
  null
  
)

export default component.exports